import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=f6ac1424&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.scss?vue&type=style&index=0&id=f6ac1424&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ac1424",
  null
  
)

export default component.exports